export default __webpack_public_path__ + "static/on-track-8b74be003724d4956fdd2c077530d2e2.svg";